<lib-modal-layout [title]="'Add Users'" [subtitle]="''">
  <p class="text-center">Enter the email address for agency users.</p>
  <lib-ui-agency-users-form
    #usersForm
    [roles]="roles()"
    [agencyId]="data.agencyId"
    (formSubmit)="submitUsersForm($event)">
  </lib-ui-agency-users-form>

  <div class="text-center">
    <p class="m-3">An invitation email will be sent to these users with instructions to complete their registration.</p>
    <div>
      <lib-button [type]="'submit'" (click)="usersForm.submit()" [text]="'Invite'" ></lib-button>
    </div>
  </div>
</lib-modal-layout>